import { HStack, Text } from '@chakra-ui/react';
import { AddOutlineIcon } from '@diamond/shared/icons';
import type { SelectOption } from '@diamond/shared/types';
import { IconButton } from '@diamond/shared/ui';
import { Controller, useFormContext } from 'react-hook-form';

import type { FormValues } from '../../types';
import { ProductPicker } from './product-picker';

type ProductSelectorProps = {
  onPickChange: (option: SelectOption | null) => void;
  onAdd: () => void;
  isAddDisabled: boolean;
};

export function ProductSelector({
  onPickChange,
  onAdd,
  isAddDisabled,
}: ProductSelectorProps) {
  const { control, resetField } = useFormContext<FormValues>();

  return (
    <>
      <Text as="b" id="product-picker-label">
        Pilih Produk
      </Text>
      <HStack alignItems="end" marginTop={2}>
        <Controller
          control={control}
          name="product"
          render={({ field }) => (
            <ProductPicker
              value={field.value ?? null}
              onChange={(option) => {
                field.onChange(option?.value ?? '');
                onPickChange(option);
              }}
              isDisabled={false}
              placeholder="Pilih Produk"
              aria-labelledby="product-picker-label"
            />
          )}
        />
        <IconButton
          icon={<AddOutlineIcon />}
          name="tambah-produk"
          aria-label="Tambah produk ke daftar highlight"
          color="white"
          bgColor="blue"
          _hover={{ bgColor: 'azure' }}
          _active={{ bgColor: 'blue' }}
          isDisabled={isAddDisabled}
          onClick={() => {
            onAdd();
            resetField('product');
          }}
        />
      </HStack>
    </>
  );
}
